import * as z from 'zod';
import { zPassword } from './error-messages';

export const changePasswordFormSchema = z.object({
  general: z.string().optional(),
  currentPassword: z.string(),
  newPassword: zPassword,
});

export type ChangePasswordForm = z.TypeOf<typeof changePasswordFormSchema>;
